import { useEffect, useState } from 'react';
import useInterval from './useInterval';

const useIntervalState = <T>(
  callback: () => T,
  interval: number,
  deps: any[]
) => {
  const [state, setState] = useState(callback());
  const updateState = () => {
    const newValue = callback();
    if (newValue !== state) {
      setState(newValue);
    }
  };
  useInterval(updateState, interval, deps);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(updateState, deps);

  return state;
};

export default useIntervalState;
